"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var useDeepMemo_1 = __importDefault(require("./useDeepMemo"));
var async_1 = __importDefault(require("../async"));
var _a = async_1.default.actions, subscribeToUpdates = _a.subscribeToUpdates, unsubscribeFromUpdates = _a.unsubscribeFromUpdates;
var useSubscription = function (_a) {
    var variables = _a.variables, _b = _a.config, origin = _b.origin, method = _b.method, _c = _b.batch, batch = _c === void 0 ? true : _c, skip = _b.skip;
    var dispatch = react_redux_1.useDispatch();
    var _d = variables, version = _d.version, otherVariables = __rest(_d, ["version"]);
    var versionRef = react_1.useRef(version);
    versionRef.current = version;
    var memoVariables = useDeepMemo_1.default(otherVariables);
    react_1.useEffect(function () {
        if (skip)
            return;
        var vars = memoVariables;
        if (typeof versionRef.current === 'string') {
            vars = __assign(__assign({}, memoVariables), { version: versionRef.current });
        }
        dispatch(subscribeToUpdates(origin, method, vars, batch));
        return function () {
            dispatch(unsubscribeFromUpdates(origin, method, vars, batch));
        };
    }, [batch, dispatch, method, origin, memoVariables, skip]);
};
exports.default = useSubscription;
//# sourceMappingURL=useSubscription.js.map